
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    REPROCESS_ODOMETER_HOURS_GET_DEVICE_REQUEST,
    REPROCESS_ODOMETER_HOURS_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { reprocessOdoHoursGetDeviceResult, reprocessOdoHoursResult } from 'Redux/actions';


function* getDevice({ payload }) {
    try {

        let { devices, accountId } = payload;
        const QUERY = `
        query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
            result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    companyId
                    id
                    label
                    esn
                    imei
                    deviceModel {
                        id
                        name
                        manufacturerId
                        manufacturer {
                            id
                            name
                        }
                    }
                }
                total
            }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        fields: ["esn", "imei", "label"],
                        terms: devices,
                        exact: true
                    },
                    {
                        fields: ["companyId"],
                        terms: [accountId],
                        exact: true
                    }
                ],
                limit: 500,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(reprocessOdoHoursGetDeviceResult(data?.result))
        } else {
            yield put(reprocessOdoHoursGetDeviceResult({ error: true }))
        }

    } catch (exc) {
        yield put(reprocessOdoHoursGetDeviceResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/reprocessOdoHours/redux/saga",
            "getDevice",
        )
    }
}

function* reprocessOdoHours({ payload }) {
    try {
        let { companyId, reprocessAll, unitIds, startDate, type } = payload
        let QUERY = `
            mutation reprocessOdoHrs ($companyId: Int!, $reprocessAll: Boolean!, $unitIds: [Int]!, $startDate: AWSDateTime!, $type: String!) {
                response: reprocessOdoHrs (companyId: $companyId, reprocessAll: $reprocessAll, unitIds: $unitIds, startDate: $startDate, type: $type){
                    stepFunctionId
                    transactionId
                    transactionType
                    processStartDate
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                companyId,
                reprocessAll,
                unitIds,
                startDate,
                type
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(reprocessOdoHoursResult({ result: data?.response }))

    } catch (exc) {
        yield put(reprocessOdoHoursResult({ error: exc }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/reprocessOdoHours/redux/saga",
            "reprocessOdoHours",
        )
    }
}

export const getAccounts = async (input = '') => {
    try {
        let QUERY = `
        query searchCompanies ($conditions: [CompanySearchInput], $sort: [CompanySortInput], $limit: Int, $offset: Int) {
            result: searchCompanies (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                    status
                }
            }
        }`
        return await clientQuery(QUERY, {
            conditions: {
                fields: [
                    "name"
                ],
                terms: [
                    input
                ],
                exact: false
            },
            limit: 10
        }, endpoints.GRAPHQL_GENERAL);
    } catch (exc) {
        ExceptionManager(exc, 'Modules/activities/.components/tab/redux/saga', 'searchAuditlogs');
    }
}

function* watchMethods() {
    yield takeEvery(REPROCESS_ODOMETER_HOURS_GET_DEVICE_REQUEST, getDevice);
    yield takeEvery(REPROCESS_ODOMETER_HOURS_REQUEST, reprocessOdoHours);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}